null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.25/scalalib/overrides/scala/util/control/NoStackTrace.scala